import catalog from './data/project-results.generated.json';
import assets from './data/project-cover-assets.generated.json';

// All website surfaces use the same shipped, content-versioned cover URL.
// COS keys remain source/archive metadata, not browser image URLs.
const covers: Record<string, { url: string }> = assets.covers;
export default {
  ...catalog,
  projects: catalog.projects.map(project => {
    const cover = covers[project.coverUrl];
    if (!cover) throw new Error(`Missing published cover: ${project.id}`);
    return { ...project, coverUrl: cover.url };
  }),
};
